module.exports = __webpack_public_path__ + "static/CookieRun-Regular.subset-33f10da6ea6bd6c119a4508581a57c91.otf";